import React, { useState } from "react";
import cx from "classnames";
import { importImage } from "lib/legacy";
import { Trans } from "@lingui/macro";
import { useTokenPrices } from "lib/api/useTokenPrices";
import { usePlpPrice } from "pages/Event/hooks/blockchain/usePlpPrice";
import { formatAmount } from "pages/Event/utils/formatAmount";

const palmIcon = importImage("PalmToken.svg");
const plpIcon = importImage("plpIcon.png");
const tetherIcon = importImage("tetherIcon.png");

const titleArrowOne = importImage("EventTitleArrow1.svg");
const titleArrowTwo = importImage("EventTitleArrow2.svg");
const titleArrowThree = importImage("EventTitleArrow3.svg");

const EventHeader = () => {
  const { price: palmPrice } = useTokenPrices("PALM");
  const { price: usdtPrice } = useTokenPrices("USDT");
  const plpPrice = usePlpPrice();

  const [buttonHovered, setButtonHovered] = useState({
    tether: false,
    plp: false,
    palm: false,
  });

  const handleMouseEnter = (button) => {
    setButtonHovered((prevState) => ({
      ...prevState,
      [button]: true,
    }));
  };

  const handleMouseLeave = (button) => {
    setButtonHovered((prevState) => ({
      ...prevState,
      [button]: false,
    }));
  };
  return (
    <div className="flex py-[8rem]  @[100rem]/page-content:py-[5rem] pb-[12rem] flex @container/page-content align-center justify-center relative isolate mb-[4rem]">
      <div className="flex flex-col text-center items-center w-full z-1">
        <div>
          <div className="absolute top-[-5rem] left-0 @[100rem]/page-content:top-0 @[100rem]/page-content:left-[8.5rem]">
            <div
              className={cx([
                "h-[3.9rem] w-[13.5rem] gap-10 rounded-[1rem] bg-gradient-to-r from-[#edebf7] to-[#d2cefe] relative flex flex-column   mb-[1rem] text-black font-bold transition-effect opacity-0",
                {
                  "opacity-100": buttonHovered.tether,
                },
              ])}
            >
              <span className="mt-auto mb-auto">1 USDT = ${formatAmount(usdtPrice, { mantissa: 2 })}</span>
              <div className="w-[1rem] h-[1rem] rotate-45 bg-[#E1DEFA] absolute bottom-[-0.5rem] left-0 right-0 ml-auto mr-auto"></div>
            </div>

            <div
              className="h-[5rem] w-[13.1rem] rounded-[50rem] bg-white/5 transition-effect hover:bg-white/[15%] flex items-center p-1 gap-5  border border-solid cursor-pointer z-10 relative"
              onMouseEnter={() => handleMouseEnter("tether")}
              onMouseLeave={() => handleMouseLeave("tether")}
            >
              <img src={tetherIcon} alt="tether" className="h-[4.4rem] w-auto" />
              <span>USDT</span>
            </div>
          </div>

          <img
            src={titleArrowOne}
            alt="arrow"
            className="absolute top-[-2rem] left-[12rem] @[100rem]/page-content:top-[2rem] @[100rem]/page-content:left-[21rem]"
          />

          <div className="absolute top-[20rem] @[100rem]/page-content:top-[14rem] left-0 @[100rem]/page-content:left-[8rem]">
            <div
              className={cx([
                "h-[3.9rem] w-[13.5rem] gap-10 rounded-[1rem] bg-gradient-to-r from-[#edebf7] to-[#d2cefe] relative flex flex-column   mb-[1rem] text-black font-bold transition-effect opacity-0",
                {
                  "opacity-100": buttonHovered.plp,
                },
              ])}
            >
              {/* Need to update price dynamically */}
              <span className="mt-auto mb-auto">1 PLP = ${formatAmount(plpPrice.formatted, { mantissa: 2 })}</span>
              <div className="w-[1rem] h-[1rem] rotate-45 bg-[#E1DEFA] absolute bottom-[-0.5rem] left-0 right-0 ml-auto mr-auto"></div>
            </div>

            <div
              className="h-[5rem] w-[13.1rem] rounded-[50rem] transition-effect bg-white/5 hover:bg-white/[15%] pointer flex items-center p-1 gap-5 border border-solid cursor-pointer z-10 relative"
              onMouseEnter={() => handleMouseEnter("plp")}
              onMouseLeave={() => handleMouseLeave("plp")}
            >
              <img src={plpIcon} alt="plp" className="h-[4.4rem] w-auto" />
              <span>PLP</span>
            </div>
          </div>

          <img
            src={titleArrowTwo}
            alt="arrow"
            className="absolute @[100rem]/page-content:rotate-0 rotate-[80deg] top-[18rem] @[100rem]/page-content:top-[15rem] right-[-2rem] @[100rem]/page-content:left-[21.5rem]"
          />

          <div className="absolute top-[19rem] @[100rem]/page-content:top-[5rem] right-0 @[100rem]/page-content:right-[9rem]">
            <div
              className={cx([
                "h-[3.9rem] w-[13.5rem] gap-10 rounded-[1rem] bg-gradient-to-r from-[#edebf7] to-[#d2cefe] relative flex flex-column   mb-[1rem] text-black font-bold transition-effect opacity-0",
                {
                  "opacity-100": buttonHovered.palm,
                },
              ])}
            >
              {/* Need to update price dynamically */}
              <span className="mt-auto mb-auto">1 PALM = ${formatAmount(palmPrice, { mantissa: 3 })}</span>
              <div className="w-[1rem] h-[1rem] rotate-45 bg-[#E1DEFA] absolute bottom-[-0.5rem] left-0 right-0 ml-auto mr-auto"></div>
            </div>

            <div
              className="h-[5rem] w-[13.1rem] rounded-[50rem] transition-effect bg-white/5 hover:bg-white/[15%] flex items-center p-1 gap-5  border border-solid cursor-pointer z-10 relative"
              onMouseEnter={() => handleMouseEnter("palm")}
              onMouseLeave={() => handleMouseLeave("palm")}
            >
              <img src={palmIcon} alt="palm" className="h-[4.4rem] w-auto" />
              <span>PALM</span>
            </div>
          </div>
        </div>
        <img
          src={titleArrowThree}
          alt=" arrow"
          className="absolute rotate-[280deg]  @[100rem]/page-content:rotate-0 top-[18rem] @[100rem]/page-content:top-[10rem] left-[-3rem] @[100rem]/page-content:left-[82rem] "
        />
        <h1 className="text-[3.4rem] @[100rem]/page-content:text-[6rem]  font-extrabold bg-gradient-to-bl text-transparent bg-clip-text from-[#6329fa] to-[#7156d8] font-mazzard ">
          <Trans>
            PALMSWAP <br /> LIQUIDITY EVENT
          </Trans>
        </h1>
        <span className="text-[1.4rem] leading-[1.5] text-inactive max-w-sm  @[100rem]/page-content:max-w-none">
          <Trans> Stake PLP to earn 50% of trading fees, borrow fees and mint/buy fees</Trans>
        </span>
      </div>
    </div>
  );
};

export default EventHeader;
